import { svgIconClassName } from '@archipro-design/icons';
import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const Delivery: StyleRule = ({ theme }) => ({
    lineHeight: pxToRem(16),
    marginTop: pxToRem(4),
    fontSize: pxToRem(16),
    color: theme.siteVariables.colors.grey[300],
    [theme.screen.tablet]: {
        marginTop: pxToRem(2),
        letterSpacing: theme.siteVariables.letterSpacingMedium,
        lineHeight: 1.3,
    },
});

export const Region: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal[300],
    display: 'block',
    cursor: 'pointer',
    textUnderlineOffset: pxToRem(2),
    pageBreakInside: 'avoid',
    lineHeight: pxToRem(26),
    [theme.screen.tablet]: {
        display: 'inline-block',
    },
});

export const Icon: StyleRule = ({ theme }) => ({
    display: 'inline-block',
    width: pxToRem(18),
    height: pxToRem(16),
    ['& .' + svgIconClassName]: {
        color: theme.siteVariables.colors.charcoal[250],
        marginLeft: pxToRem(1),
        width: pxToRem(22),
        height: pxToRem(22),
    },
});

export const DeliverySelectIcon: StyleRule = () => ({
    display: 'inline-block',
    width: pxToRem(10),
    marginLeft: pxToRem(6),
});

export const DeliveryEstimate: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(4),
    [theme.screen.tablet]: {
        marginTop: theme.siteVariables.spaces['space-8'],
    },
});

export const MetFreeThreshold: StyleRule = () => ({
    textDecoration: 'line-through',
});

export const FreeShippingThreshold: StyleRule = ({ theme }) => ({
    marginTop: theme.siteVariables.spaces['space-8'],
    [theme.screen.tablet]: {
        marginTop: pxToRem(1),
    },
});
